import { MallAxiosInterceptor } from "api/core/consts";

export const qnaReply = {
  getMallQnAReply: (mallQnAReplyId) => MallAxiosInterceptor.get('mallQnAReply/' + mallQnAReplyId),
  searchMallQnAReply: (paging, body) => MallAxiosInterceptor.post('mallQnAReply/search' + paging, body),
  createMallQnAReply: (body) => MallAxiosInterceptor.post('mallQnAReply', body),
  updateMallQnAReply: (mallQnAReplyId, body) => MallAxiosInterceptor.put('mallQnAReply/' + mallQnAReplyId, body),
  deleteMallQnAReply: (mallQnAReplyId) => MallAxiosInterceptor.delete('mallQnAReply/' + mallQnAReplyId),
};
